module.exports = __webpack_public_path__ + "static/img/manager.5799d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager.png
// module id = 310
// module chunks = 6